export enum AlertType {
    info = 'info',
    warning = 'warning',
    error = 'danger',
    success = 'success'
}
